import { useQuery } from "@tanstack/react-query";
import { publicHolidayKeys } from "./publicHoliday.keys";
import { useApi } from "../../api/ApiProvider";

/**
 * Hook to fetch public holidays by year and optionally bundesland
 */
export const usePublicHolidays = (
  year?: number,
  bundesland?: string,
  enabled: boolean = true
) => {
  const { publicHoliday } = useApi();
  
  return useQuery({
    queryKey: bundesland 
      ? publicHolidayKeys.publicHolidays.byYearAndBundesland(year!, bundesland)
      : year 
        ? publicHolidayKeys.publicHolidays.byYear(year)
        : publicHolidayKeys.publicHolidays.all(),
    queryFn: () => publicHoliday.getPublicHolidays(year, bundesland),
    meta: { errorMessage: "Feiertage konnten nicht geladen werden" },
    staleTime: 10 * 60 * 1000, // 10 minutes
    enabled: enabled && (year !== undefined || bundesland !== undefined),
  });
};

/**
 * Hook to fetch a single public holiday by ID
 */
export const usePublicHoliday = (id: number, enabled: boolean = true) => {
  const { publicHoliday } = useApi();
  
  return useQuery({
    queryKey: publicHolidayKeys.publicHolidays.detail(id),
    queryFn: () => publicHoliday.getPublicHoliday(id),
    meta: { errorMessage: "Feiertag konnte nicht geladen werden" },
    enabled: enabled && id > 0,
  });
};